module.exports = __webpack_public_path__ + "static/img/banner01.f816425.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/banner01.png
// module id = Bop5
// module chunks = 1